import { ChevronDownIcon } from '@heroicons/react/24/outline';
import {
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionTrigger
} from '@radix-ui/react-accordion';
import type { ReactNode } from 'react';

import type { Steps } from './steps';
import { StepStatusCircle } from './StepStatusCircle';

type Props = {
  children: ReactNode;
  name: Steps;
  header: string;
  index: string;
  isFinished: boolean;
  hasError?: boolean;
};

export const StepItem = ({
  children,
  name,
  header,
  index,
  isFinished,
  hasError
}: Props) => {
  return (
    <AccordionItem value={name} className="rounded-2xl bg-white">
      <AccordionHeader>
        <AccordionTrigger className="group flex w-full cursor-pointer items-center justify-start gap-2 px-6 py-4 outline-offset-[-1px] group-last:radix-state-closed:rounded-b-lg">
          <StepStatusCircle
            step={name}
            value={index}
            isFinished={isFinished}
            hasError={hasError}
          />
          <h2 className="font-semibold">{header}</h2>
          <ChevronDownIcon className="group-radix-state-open:scale-flip ml-auto w-7 transition-all duration-300 group-hover:!stroke-content-primary group-radix-state-closed:stroke-content-muted" />
        </AccordionTrigger>
      </AccordionHeader>
      <AccordionContent>{children}</AccordionContent>
    </AccordionItem>
  );
};
